import { render, staticRenderFns } from "./politica.vue?vue&type=template&id=664e44b8&scoped=true&"
import script from "./politica.vue?vue&type=script&lang=js&"
export * from "./politica.vue?vue&type=script&lang=js&"
import style0 from "./politica.vue?vue&type=style&index=0&id=664e44b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e44b8",
  null
  
)

export default component.exports